import { useAppSelector } from '~store/hooks/store';
import { by } from '@qodly/shared';
import { FLAGS_KEYS } from './reducer';

export const useModelSelector = () => {
  return useAppSelector((state) => state.model);
};

export const useDataclasses = () => {
  return useAppSelector((state) => state.model.draft.dataClasses);
};

export const useCollections = () => {
  return useAppSelector((state) => state.model.draft.collections);
};

export const useDataclass = (dataclassId: string) => {
  return useAppSelector((state) => state.model.draft.dataClasses[dataclassId]);
};

export const useAttribute = (dataclassId: string, attributeId: string) => {
  return useAppSelector((state) =>
    state.model.draft.dataClasses[dataclassId].attributes.find(
      by('name', attributeId),
    ),
  );
};

export const useModelViewport = () => {
  return useAppSelector(
    (state) =>
      state.settings.session[
        'model.viewport'
      ] as catalog.IModelProperties['viewport'],
  );
};

export const useModelFlags = () => {
  const flags = useAppSelector((state) => state.model.flags);

  const getFlagValue = (key: string) => (key in flags ? flags[key] : undefined);

  const deleteDataclass = getFlagValue(FLAGS_KEYS.DATACLASS_DELETE);
  const draggableDataclass = getFlagValue(FLAGS_KEYS.DATACLASS_DRAGGABLE);

  return {
    deleteDataclass,
    draggableDataclass,
    flags,
  };
};
